import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { groupBy } from 'lodash';
import { InvestmentAllocation } from '../../../types';

const useFormatInvestorAllocationsData = () => {
  const { getValues } = useFormContext<rules.CreateRealisationFormValues>();

  const formatInvestorAllocationsData = (
    index: number,
  ): Record<string, Array<InvestmentAllocation>> => {
    const investorAllocations = getValues(
      `consideration.${index}.investorAllocations`,
    );

    const formattedInvestorAllocations = groupBy(
      investorAllocations,
      'investmentId',
    );

    return formattedInvestorAllocations as Record<
      string,
      Array<InvestmentAllocation>
    >;
  };

  return { formatInvestorAllocationsData };
};

export default useFormatInvestorAllocationsData;
